import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useExperiment } from '@/libraries/experiment';
import { getExperimentAffiliateTag } from '@/libraries/experiment/experiment-affiliation';

export function usePrimeSQTVExp() {
	const { activeVariantWithControlGroup: variant, experimentInfo } = useExperiment('EXP_PRIME_SQTV');

	function setPrimeSQTVExpTags(url: ClickoutUrl, placement: 'sqtv' | 'ft') {
		if (!variant.value) return url;

		const affiliationShortId = experimentInfo.value.affiliationShortId as string;

		const tag = getExperimentAffiliateTag({
			affiliationShortId,
			variant: variant.value,
			country: 'US',
			placement,
			providerShortName: 'amp',
		});

		url.set('uct_ctag', tag);

		return url;
	}

	return {
		setPrimeSQTVExpTags,
	};
}
